const WEB_URL_PATTERN = /^https?:\/\/\S+$/i;
const EMAIL_ADDRESS_PATTERN = /^[^\s@:]+@[^\s@.]+(\.[^\s@.]+)+$/;
const MAILTO_URL_PATTERN = /^mailto:([^\s?]+)(\?\S*)?$/i;

export const MAILTO_SCHEME = 'mailto:';

const isMailtoUrl = (url: string): boolean => {
  const match = MAILTO_URL_PATTERN.exec(url);
  return match !== null && EMAIL_ADDRESS_PATTERN.test(match[1]);
};

export const isSupportedLinkUrl = (url: string): boolean =>
  WEB_URL_PATTERN.test(url) || isMailtoUrl(url);

export const normaliseLinkUrl = (input: string): string => {
  const trimmed = input.trim();
  return EMAIL_ADDRESS_PATTERN.test(trimmed)
    ? `${MAILTO_SCHEME}${trimmed}`
    : trimmed;
};

const HAS_SCHEME_PATTERN = /^(https?:\/\/|mailto:)/i;
const DEFAULT_SCHEME = 'https://';

export const withDefaultScheme = (url: string): string =>
  HAS_SCHEME_PATTERN.test(url) ? url : `${DEFAULT_SCHEME}${url}`;
